import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Nav,
  Row,
  Tab,
  Spinner,
} from "react-bootstrap";
import TableData from "./Component/tableData";
import AddNewUser from "./Component/Modal/AddNewUser";
import add_new from "../../../Assets/svg/add_new.svg";
import { useSelector } from "react-redux";
import { get, updateToken } from "../../../helpers/api_helper";
import Pagination from "../../../components/Pagination";
import { USERS_LISTING } from "../../../helpers/url_helper";

const User = () => {
  const token = useSelector((state) => state.login.token);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("create");
  const [userData, setUserData] = useState([]);
  const [selectedUserData, setSelectedUserData] = useState(null);
  const [activeTab, setActiveTab] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState("createdAt");
  const [orderBy, setOrderBy] = useState("desc");

  const fetchUser = useCallback(
    async (page = 1, status = "all", sortBy = "createdAt", orderBy = "desc") => {
      try {
        setLoading(true);
        const skip = currentPage + page - 1;
        const limit = itemsPerPage;
        const statusQuery = status === "All" ? "" : status;

        const response = await get(
          `${USERS_LISTING}?skip=${skip}&limit=${limit}&status=${statusQuery.toLowerCase()}&orderBy=${sortBy}&sortBy=${orderBy}`
        );

        if (response?.success) {
          setUserData(response?.data?.items || []);
          setTotalPages(response?.data?.totalPages || 0);
        } else {
          console.log("Failed to fetch users");
          setUserData([]);
        }
      } catch (error) {
        console.log("An error occurred while fetching users", error);
        setUserData([]);
      } finally {
        setLoading(false);
      }
    },
    [itemsPerPage]
  );

  useEffect(() => {
    if (token) {
      updateToken(token);
      fetchUser(currentPage, activeTab, sortBy, orderBy);
    }
  }, [token, fetchUser, currentPage, activeTab, sortBy, orderBy]);

  const handleAddUser = () => {
    setModalMode("create");
    setSelectedUserData(null);
    setShowModal(true);
  };

  const handleEditUser = (data) => {
    setModalMode("edit");
    setSelectedUserData(data);
    setShowModal(true);
  };

  const handleTabChange = (status) => {
    setActiveTab(status);
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleSort = (field) => {
    const newOrderBy = sortBy === field && orderBy === "asc" ? "dsc" : "asc";
    setSortBy(field);
    setOrderBy(newOrderBy);
    setCurrentPage(1);
  };

  return (
    <>
      <AddNewUser
        showModal={showModal}
        setShowModal={setShowModal}
        setRefresh={() => fetchUser(currentPage, activeTab, sortBy, orderBy)}
        mode={modalMode}
        userData={selectedUserData}
        resetFormOnClose={showModal}
      />
      <section className="userSec position-relative py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="d-flex align-items-center sectionHeader justify-content-between gap-10 flex-wrap filterBtns">
                <div className="left">
                  <h4 className="m-0 fw-bold">New Customer List</h4>
                  <p className="m-0 text-muted py-1">
                    Contrary to popular belief, Lorem Ipsum is not simply random
                    text.
                  </p>
                </div>
                <div className="right d-flex align-items-center flex-wrap gap-10">
                  <Button
                    onClick={handleAddUser}
                    className="d-flex align-items-center justify-content-center rounded-pill"
                  >
                    Add new User{" "}
                    <span className="icn ms-2">
                      <img src={add_new} alt="" />
                    </span>
                  </Button>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <Tab.Container
                id="left-tabs-example"
                activeKey={activeTab}
                onSelect={(k) => handleTabChange(k)}
              >
                <div className="commonTable">
                  <div
                    className="top px-3 pt-2 d-flex align-items-center justify-content-between gap-10"
                    style={{ background: "#F5F7FA" }}
                  >
                    <div className="left">
                      <Nav
                        variant="pills"
                        className="transparentBtn-Tab py-2 gap-10"
                      >
                        <Nav.Item>
                          <Nav.Link
                            eventKey="All"
                            className="p-0 bg-transparent px-2"
                          >
                            All
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="Active"
                            className="p-0 bg-transparent px-2"
                          >
                            Active
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="Inactive"
                            className="p-0 bg-transparent px-2"
                          >
                            Inactive
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </div>
                  </div>

                  <Tab.Content>
                    {loading ? (
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: "100px" }}
                      >
                        <Spinner animation="border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </Spinner>
                      </div>
                    ) : userData.length > 0 ? (
                      <>
                        <Tab.Pane eventKey="All">
                          <div className="scrollable-table-container">
                            <TableData
                              userData={userData}
                              setRefresh={() =>
                                fetchUser(
                                  currentPage,
                                  activeTab,
                                  sortBy,
                                  orderBy
                                )
                              }
                              handleEditUser={handleEditUser}
                              handleSort={handleSort}
                              sortBy={sortBy}
                              orderBy={orderBy}
                            />
                          </div>
                          {totalPages > 1 && (
                            <Pagination
                              currentPage={currentPage}
                              totalPages={totalPages}
                              onPageChange={handlePageChange}
                            />
                          )}
                        </Tab.Pane>

                        <Tab.Pane
                          eventKey="Active"
                          className="scrollable-table-container"
                        >
                          <TableData
                            userData={userData}
                            setRefresh={() =>
                              fetchUser(currentPage, activeTab, sortBy, orderBy)
                            }
                            handleEditUser={handleEditUser}
                            handleSort={handleSort}
                            sortBy={sortBy}
                            orderBy={orderBy}
                          />
                          {totalPages > 1 && (
                            <Pagination
                              currentPage={currentPage}
                              totalPages={totalPages}
                              onPageChange={handlePageChange}
                            />
                          )}
                        </Tab.Pane>

                        <Tab.Pane
                          eventKey="Inactive"
                          className="scrollable-table-container"
                        >
                          <TableData
                            userData={userData}
                            setRefresh={() =>
                              fetchUser(currentPage, activeTab, sortBy, orderBy)
                            }
                            handleEditUser={handleEditUser}
                            handleSort={handleSort}
                            sortBy={sortBy}
                            orderBy={orderBy}
                          />
                          {totalPages > 1 && (
                            <Pagination
                              currentPage={currentPage}
                              totalPages={totalPages}
                              onPageChange={handlePageChange}
                            />
                          )}
                        </Tab.Pane>
                      </>
                    ) : (
                      <p>No user data available.</p>
                    )}
                  </Tab.Content>
                </div>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default User;
